import { useContext } from "react";

import Person from "./person/person.component";

import { ClientsContext } from "src/contexts/clients.context";

import "./people-tab.style.scss";
import { getItemWhere } from "utils/array.utils";

const sortEmployeeList = (list) => {
	const admins = list.filter((person) => person.userType === 0);
	const members = list.filter((person) => person.userType === 1);
	return [...admins, ...members];
};

const PeopleTab = ({ id }) => {
	const { clients } = useContext(ClientsContext);

	const { companyType } = getItemWhere(clients, "id", id);

	let data, color;
	if (companyType === 0) {
		data = getItemWhere(clients, "id", id);
		({ color } = data);
	} else if (companyType === 1) {
		data = getItemWhere(clients, "id", id).employees;
		({ color } = getItemWhere(clients, "id", id).company);
		data = sortEmployeeList(data);
	}

	if (companyType === 0) {
		return <Person data={data} color={color} />;
	}

	return (
		<div className="people-tab-container">
			{data.map((employee, index) => {
				return <Person key={index} data={employee} color={color} />;
			})}
		</div>
	);
};

export default PeopleTab;
